import { cultivoApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'CULTIVO',
    api: cultivoApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'CULTIVO',
  api: cultivoApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'CULTIVO',
    api: cultivoApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'CULTIVO',
    api: cultivoApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'CULTIVO',
  api: cultivoApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'CULTIVO',
    api: cultivoApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('CULTIVO');
export const setDeletedPending = createListDataDeletedPending('CULTIVO');
